import React, { useCallback, useMemo, useState } from "react";

import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import UploadFileIcon from "@mui/icons-material/UploadFile";

import ButtonUI from "./ButtonUI";

import { regexFilePath } from "../../util/regularExpress";
import S3FileBrowser from "../MyWorkspace/Browsers/S3FileBrowser";
import AzureFileBrowser from "../MyWorkspace/Browsers/AzureFileBrowser";

const browserStateVar = {
  azure: "azureBrowser",
  s3: "s3Browser",
};

const BrowseInput = ({ setPath, connections, connection, path, disabled }) => {
  const [tmpBucket, setTmpBucket] = useState("");
  const [openBrowser, setOpenBrowser] = useState({
    azureBrowser: false,
    s3Browser: false,
  });

  const container = useMemo(
    () => (connection && connections.find(({ Stage_id }) => Stage_id === connection)?.Detail.container) || "",
    [connection, connections]
  );

  const handleBrowser = useCallback((browser, val) => {
    const prop = browserStateVar[browser];
    setOpenBrowser((prev) => {
      const newState = {};
      Object.keys(prev).forEach((key) => {
        newState[key] = key === prop ? val : false;
      });

      return newState;
    });
  }, []);

  const handleBrowseClick = useCallback(() => {
    const locationDetail = connections.find((locationDetail) => locationDetail.Stage_id === connection);

    if (locationDetail) {
      const Detail = locationDetail.Detail;
      setTmpBucket(Detail.url);
      handleBrowser(Detail.type.toLowerCase(), true);
    }
  }, [connections, connection, handleBrowser]);

  const handleS3Browser = useCallback((val) => handleBrowser("s3", val), [handleBrowser]);
  const handleAzureBrowser = useCallback((val) => handleBrowser("azure", val), [handleBrowser]);

  return (
    <>
      <Grid container sx={{ width: "100%" }}>
        <Grid size={6}>
          <TextField
            disabled={disabled}
            fullWidth
            value={path}
            required={!disabled}
            label="Folder path"
            inputProps={{ maxLength: 255 }}
            onChange={(e) => {
              if (e.target.value === "") setPath("");
              else if (regexFilePath(e.target.value)) setPath(e.target.value);
            }}
            onBlur={() => {
              if (path && path[0] !== "/") setPath("/" + path);
              if (path && !path.endsWith("/")) setPath(path + "/");
            }}
            helperText={`Not allowed characters \\:;~*'?"<>|`}
          />
        </Grid>
        <Grid size={6}>
          <ButtonUI
            disabled={!connection || disabled}
            color="secondary"
            component="span"
            variant="contained"
            endIcon={<UploadFileIcon />}
            style={{
              marginTop: "10px",
              marginLeft: "18px",
            }}
            onClick={handleBrowseClick}
          >
            Browse
          </ButtonUI>
        </Grid>
      </Grid>
      {openBrowser.s3Browser && (
        <S3FileBrowser
          setOpenFileBrowser={handleS3Browser}
          url={tmpBucket}
          path={path}
          setPath={setPath}
          stage={connection}
          locationName={connection && connections.find((loc) => loc.Stage_id === connection).Name}
          folderSelection
        />
      )}
      {openBrowser.azureBrowser && (
        <AzureFileBrowser
          container={container}
          setOpenFileBrowser={handleAzureBrowser}
          stage={connection}
          locationName={connection && connections.find((loc) => loc.Stage_id === connection).Name}
          path={`${
            path
              ? "/" +
                path
                  .split(",/")
                  .map((p, i) => `${container}${i === 0 ? "" : "/"}${p}`)
                  .join(",/")
              : `/${container}/`
          }`}
          setPath={(pathValue) => {
            setPath(
              pathValue.replace(new RegExp(`^/${container}`), "").replace(new RegExp(`,/${container}`, "g"), ",")
            );
          }}
          folderSelection
        />
      )}
    </>
  );
};

export default BrowseInput;
